import { RentalsLayout as RentalsLayoutComponent } from '@zillow/zrs-cms';
import React from 'react';

import LayoutWrapper, { LayoutWrapperProps } from '../LayoutWrapper';

const RentalsLayout: React.FC<LayoutWrapperProps> = (props) => {
    return (
        <LayoutWrapper
            {...props}
            LayoutComponent={RentalsLayoutComponent}
            defaultTitle="Zillow Rentals Network"
        />
    );
};

export default RentalsLayout;
